import { useMemo } from 'react'

import { useSession, useTenant } from '@rewardops/auth'
import { Section as SectionType } from '@rewardops/utils'

export const useContentfulSectionFilter = ({
  sections,
}: {
  sections: SectionType[] | undefined
}) => {
  const tenant = useTenant()
  const { data: session } = useSession()

  const isLoggedIn = Boolean(session)
  const hasPawDashboard = sections?.some(
    (section) => section?._type === 'pawDashboard',
  )
  const role = session?.user?.member?.role

  const filteredSections = useMemo(() => {
    if (!sections || !hasPawDashboard) {
      return sections
    }

    if (!tenant?.flags?.pawDashboard || !isLoggedIn) {
      return sections?.filter((section) => section?._type !== 'pawDashboard')
    }

    if (isLoggedIn && hasPawDashboard && role) {
      return sections?.filter(
        (section) =>
          section?._type === 'pawDashboard' && (section as any)?.role === role,
      )
    }

    return sections
  }, [sections, isLoggedIn, hasPawDashboard, tenant?.flags?.pawDashboard, role])

  return filteredSections
}
